import { forwardRef } from "react";
import { cx } from "shared/utils";
import { useMentionHandler } from "./hooks/useMentionHandler";
import { LiteTextEditorProps } from "shared/components/Editor/core/types/editor";
import { EditorRefApi } from "shared/components/Editor/core/types/editor";
import { LiteTextEditorWithRef } from "shared/components/Editor";

type LiteTextEditorWrapperProps = Omit<
  LiteTextEditorProps,
  "mentionHandler"
> & {
  editable: boolean;
  disableMentions?: boolean;
  applicationId?: string;
  propertyName?: string;
  onEditModeChange?: (isEditing: boolean) => void;
};

export const LiteTextEditor = forwardRef<
  EditorRefApi,
  LiteTextEditorWrapperProps
>((props, ref) => {
  const {
    autoExpandConfig,
    containerClassName,
    editable,
    disableMentions,
    applicationId,
    propertyName,
    onEditModeChange,
    ...rest
  } = props;
  const mentionHandler = useMentionHandler({ applicationId, propertyName });

  return (
    <LiteTextEditorWithRef
      ref={ref}
      autoExpandConfig={autoExpandConfig}
      onBlur={() => {
        onEditModeChange?.(false);
      }}
      onEditorFocus={() => {
        onEditModeChange?.(true);
      }}
      editable={editable}
      mentionHandler={disableMentions ? undefined : mentionHandler}
      {...rest}
      containerClassName={cx(containerClassName, "relative")}
    />
  );
});

LiteTextEditor.displayName = "LiteTextEditor";
